import { InfluencerProfileOverview, InfluencerProfileOverviewProps } from '../shared';

type InfluencerXhsProfileOverviewProps = InfluencerProfileOverviewProps;

export const InfluencerXhsProfileOverview = (props: InfluencerXhsProfileOverviewProps) => (
  <InfluencerProfileOverview {...props} />
);
